/* ==========================================================================
   HART for Shopify: the small behaviours of the HART sections.
   The entrance (homepage, once per session), polished silver catching the light once, the Front and Back switch
   on cards, the matching-set chips, the outfit-ideas row and the details. Build Your Match is in hart-match.js.
   Everything here works on top of server-rendered markup: with no script, every section still reads and links.
   ========================================================================== */
(function () {
  'use strict';
  var D = document, W = window;
  function $(s, r) { return (r || D).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); }
  function reduced() { try { return W.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; } }

  /* ------------------------------------------------------------- entrance --
     First visit of a session, homepage only: the screen goes dark, the double Hart draws itself, then opens as
     a window onto the store. About two seconds. Skip, any tap or click, any key or a scroll ends it at once.
     Never with reduced motion, in the theme editor or twice in one session (decided before first paint in
     layout/theme.liquid, which also loads the mark's timing map, assets/hart-mark.js). */
  var introBusy = false;
  function entrance() {
    var box = $('#hart-intro'), cv = $('#hart-intro-cv'), root = D.documentElement;
    if (!box || !cv) { root.classList.remove('is-intro'); return; }
    var pathEl = D.getElementById('hart-mark-path');
    var MARK = { vw: 997.3, vh: 851.6, d: pathEl ? pathEl.getAttribute('d') : '' };
    function settle() {
      introBusy = false; root.classList.remove('is-intro'); box.classList.remove('is-open', 'is-out');
      try { W.sessionStorage.setItem('hart.intro', '1'); } catch (e) {}
    }
    if (introBusy) return;
    introBusy = true;
    root.classList.add('is-intro');
    var state = 'load', raf = 0, dog = 0, gone = false;
    function finish(fade) {
      if (state === 'done') return; state = 'done';
      W.cancelAnimationFrame(raf); W.clearTimeout(dog);
      D.removeEventListener('keydown', onKey, true); W.removeEventListener('resize', onSize);
      box.removeEventListener('pointerdown', skip); box.removeEventListener('click', skip); box.removeEventListener('wheel', skip); box.removeEventListener('touchmove', skip);
      if (fade === true) { box.classList.add('is-out'); W.setTimeout(settle, 220); } else settle();
    }
    function skip() { finish(true); }
    function onKey(e) {
      if (/^(Shift|Control|Alt|Meta|CapsLock)$/.test(e.key)) return;
      if (e.key === ' ' || e.key === 'Escape' || e.key === 'Enter') e.preventDefault();
      finish(true);
    }
    function onSize() { if (state === 'run') layout(); }
    D.addEventListener('keydown', onKey, true); W.addEventListener('resize', onSize);
    box.addEventListener('pointerdown', skip); box.addEventListener('click', skip);
    box.addEventListener('wheel', skip, { passive: true }); box.addEventListener('touchmove', skip, { passive: true });
    dog = W.setTimeout(finish, 4800);             // whatever happens, the store shows

    var T = { draw: 1150, hold: 200, open: 800 }, SOFT = 0.012, SPREAD = 0.5, DECAY = 0.2;
    var ctx, path, pts, acc, t0 = 0, ink = null, geo = null, dpr = 1, Wd = 0, Ht = 0;
    function build(im) {
      var mc = D.createElement('canvas'); mc.width = MARK.mw; mc.height = MARK.mh;
      var mx = mc.getContext('2d', { willReadFrequently: true }); mx.drawImage(im, 0, 0);
      var s = mx.getImageData(0, 0, MARK.mw, MARK.mh).data, n = MARK.mw * MARK.mh, idx = [], u = [], umax = 0, k;
      for (k = 0; k < n; k++) {
        var r = s[k * 4], g = s[k * 4 + 1], b = s[k * 4 + 2];
        if (r || g || b) { var v = ((r << 8) | b) / 65535 + (g / MARK.len) / SPREAD; idx.push(k); u.push(v); if (v > umax) umax = v; }
      }
      if (!idx.length) throw new Error('empty timing map');
      ink = { map: mc, mx: mx, out: mx.createImageData(MARK.mw, MARK.mh), idx: idx, u: u, umax: umax, cv: D.createElement('canvas') };
    }
    function layout() {
      var r = box.getBoundingClientRect(); Wd = r.width; Ht = r.height; dpr = Math.min(W.devicePixelRatio || 1, 2);
      while (Wd * Ht * dpr * dpr > 5000000 && dpr > 1) dpr -= 0.25;
      cv.width = Math.round(Wd * dpr); cv.height = Math.round(Ht * dpr);
      var vh = Math.min(Ht, W.innerHeight || Ht), lw = Math.max(150, Math.min(380, Wd * 0.44, vh * 0.34)), k = lw / MARK.vw, lh = MARK.vh * k;
      var x = Wd / 2 - lw / 2, y = vh * 0.46 - lh / 2, px = x + MARK.pivot[0] * k, py = y + MARK.pivot[1] * k;
      var far = Math.max(Math.hypot(px, py), Math.hypot(Wd - px, py), Math.hypot(px, Ht - py), Math.hypot(Wd - px, Ht - py));
      geo = { k: k, x: x, y: y, px: px, py: py, zEnd: far / (MARK.pr * k) * 1.05 };
      ink.cv.width = Math.ceil((lw + 8) * dpr); ink.cv.height = Math.ceil((lh + 8) * dpr);
    }
    function smooth(x) { x = x < 0 ? 0 : x > 1 ? 1 : x; return x * x * (3 - 2 * x); }
    function at(f) {
      var l = Math.max(0, Math.min(1, f)) * acc[acc.length - 1], lo = 0, hi = acc.length - 1;
      while (hi - lo > 1) { var m = (lo + hi) >> 1; if (acc[m] < l) lo = m; else hi = m; }
      var a = pts[lo], b = pts[hi], d = acc[hi] - acc[lo] || 1, t = (l - acc[lo]) / d;
      return [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t];
    }
    function bg() { ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.globalCompositeOperation = 'source-over'; ctx.globalAlpha = 1; ctx.fillStyle = '#0f0f10'; ctx.fillRect(0, 0, cv.width, cv.height); }
    function drawInk(P) {                        // the timing map says when each point takes ink; the vector path gives the edge
      var d = ink.out.data, n = ink.idx.length, k, j, e, a, f;
      for (k = 0; k < n; k++) {
        e = P - ink.u[k]; j = ink.idx[k] * 4;
        if (e <= 0) { d[j + 3] = 0; continue; }
        a = e / SOFT; if (a > 1) a = 1; a = a * a * (3 - 2 * a);
        f = 1 - e / DECAY; if (f < 0) f = 0; f *= f;          // fresh ink runs lavender, the color of the hoodie, then settles to ivory
        d[j] = 244 - 45 * f; d[j + 1] = 241 - 59 * f; d[j + 2] = 234 - 13 * f; d[j + 3] = a * 255;
      }
      ink.mx.putImageData(ink.out, 0, 0);
      var c = ink.cv.getContext('2d'), s = geo.k * dpr, p = 4 * dpr;
      c.setTransform(1, 0, 0, 1, 0, 0); c.globalCompositeOperation = 'source-over'; c.clearRect(0, 0, ink.cv.width, ink.cv.height);
      c.imageSmoothingEnabled = true; c.imageSmoothingQuality = 'high';
      c.drawImage(ink.map, p, p, MARK.vw * s, MARK.vh * s);
      c.globalCompositeOperation = 'destination-in'; c.setTransform(s, 0, 0, s, p, p); c.fill(path, 'evenodd');
    }
    function frame(now) {
      if (state !== 'run') return;
      var t = now - t0, s = geo.k * dpr;
      if (t < T.draw + T.hold) {
        var q = Math.min(1, t / T.draw), pen = q < 0.5 ? 2 * q * q : 1 - Math.pow(-2 * q + 2, 2) / 2, P = pen * (ink.umax + SOFT + 0.02);
        bg(); drawInk(P);
        ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.drawImage(ink.cv, (geo.x - 4) * dpr, (geo.y - 4) * dpr);
        if (P < 0.99) {                          // a fine line runs just ahead of the ink
          ctx.setTransform(s, 0, 0, s, geo.x * dpr, geo.y * dpr); ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.lineWidth = 2.2 / geo.k;
          ctx.strokeStyle = 'rgba(214, 200, 232, ' + (0.85 * Math.min(1, (1 - q) * 6)).toFixed(3) + ')';
          ctx.beginPath(); var a0 = Math.min(1, P) - 0.004, a1 = Math.min(1, P + 0.06), n = 14, k2, p2;
          for (k2 = 0; k2 <= n; k2++) { p2 = at(a0 + (a1 - a0) * k2 / n); if (k2) ctx.lineTo(p2[0], p2[1]); else ctx.moveTo(p2[0], p2[1]); }
          ctx.stroke();
        }
        if (gone) { gone = false; box.classList.remove('is-open'); }
      } else {                                   // the Hart opens: a hole in the dark that grows until the store fills the screen
        var k = Math.min(1, (t - T.draw - T.hold) / T.open), z = Math.exp(Math.log(geo.zEnd) * k * k * (0.35 + 0.65 * k));
        bg();
        ctx.setTransform(1, 0, 0, 1, geo.px * dpr, geo.py * dpr); ctx.scale(s * z, s * z); ctx.translate(-MARK.pivot[0], -MARK.pivot[1]);
        ctx.globalCompositeOperation = 'destination-out'; ctx.globalAlpha = smooth(k * 3.2); ctx.fillStyle = '#000'; ctx.fill(path, 'evenodd');
        ctx.globalCompositeOperation = 'source-over'; ctx.globalAlpha = 1 - smooth(k * 3.2);
        if (ctx.globalAlpha > 0.01) { ctx.fillStyle = '#f4f1ea'; ctx.fill(path, 'evenodd'); }
        ctx.globalAlpha = 1;
        if (!gone) { gone = true; box.classList.add('is-open'); }
        if (k >= 1) { finish(); return; }
      }
      raf = W.requestAnimationFrame(frame);
    }
    function start() {
      if (state !== 'load') return;
      if (!W.HART_MARK || !MARK.d || !cv.getContext) { finish(true); return; }
      for (var key in W.HART_MARK) MARK[key] = W.HART_MARK[key];
      if (!MARK.map) { finish(true); return; }
      ctx = cv.getContext('2d'); path = new Path2D(MARK.d); pts = MARK.center; acc = [0];
      for (var i = 1; i < pts.length; i++) acc.push(acc[i - 1] + Math.hypot(pts[i][0] - pts[i - 1][0], pts[i][1] - pts[i - 1][1]));
      var im = new Image();
      im.onload = function () {
        if (state !== 'load') return;
        try { build(im); layout(); state = 'run'; t0 = W.performance.now(); frame(t0); } catch (e) { finish(); }
      };
      im.onerror = function () { finish(); };
      im.src = MARK.map;
    }
    if (W.HART_MARK) start();
    else {
      var s = $('script[data-hart-mark]');
      if (!s) { finish(true); return; }
      s.addEventListener('load', start); s.addEventListener('error', function () { finish(true); });
      W.setTimeout(function () { if (state === 'load') { if (W.HART_MARK) start(); else finish(true); } }, 1500);
    }
  }

  /* ----------------------------------------------------------------- polished silver
     The silver catches the light once (css: html.is-lit): as the entrance opens onto the store, or straight away
     when there is no entrance. Each group of glints plays the first time it comes into view, then rests. */
  function lightUp() {
    var root = D.documentElement, box = $('#hart-intro');
    function lit() { root.classList.add('is-lit'); }
    if (!root.classList.contains('is-intro') || !W.MutationObserver) W.requestAnimationFrame(lit);
    else {
      var mo = new MutationObserver(function () {
        if (!root.classList.contains('is-intro') || (box && box.classList.contains('is-open'))) { mo.disconnect(); lit(); }
      });
      mo.observe(root, { attributes: true, attributeFilter: ['class'] });
      if (box) mo.observe(box, { attributes: true, attributeFilter: ['class'] });
    }
  }
  var glintIO = null;
  function glints(scope) {
    var spots = $$('[data-glint]', scope);
    if (!('IntersectionObserver' in W)) { spots.forEach(function (el) { el.classList.add('is-in'); }); return; }
    if (!glintIO) glintIO = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); glintIO.unobserve(e.target); } });
    }, { threshold: 0.4 });
    spots.forEach(function (el) { if (!el.classList.contains('is-in')) glintIO.observe(el); });
  }

  /* ----------------------------------------------------------- outfit ideas */
  function looksSync(sec) {
    var t = $('[data-looks-track]', sec); if (!t) return;
    var max = t.scrollWidth - t.clientWidth - 2, prev = $('[data-looks-go="-1"]', sec), next = $('[data-looks-go="1"]', sec);
    if (prev) prev.disabled = t.scrollLeft <= 2;
    if (next) next.disabled = t.scrollLeft >= max;
  }
  function looksInit(scope) {
    $$('[data-looks]', scope).forEach(function (sec) {
      if (sec.hartLooks) return; sec.hartLooks = true;
      var t = $('[data-looks-track]', sec), tick = 0;
      if (t) t.addEventListener('scroll', function () { if (tick) return; tick = W.requestAnimationFrame(function () { tick = 0; looksSync(sec); }); }, { passive: true });
      looksSync(sec);
    });
  }

  /* ------------------------------------------------------------ the details */
  function insideData(root) {
    if (!root.hartData) { try { root.hartData = JSON.parse($('[data-inside-data]', root).textContent); } catch (e) { root.hartData = { colors: [], points: [] }; } root.hartColor = 0; root.hartOn = 0; }
    return root.hartData;
  }
  function swapPic(im, url, alt) {
    if (!im || !url) return;
    if (alt != null) im.alt = alt;
    if (im.getAttribute('src') === url) return;
    if (reduced()) { im.src = url; return; }
    im.classList.add('is-swap');
    var n = new Image();
    n.onload = n.onerror = function () { im.src = url; im.classList.remove('is-swap'); };
    n.src = url;
  }
  function insideShow(root, i) {
    var d = insideData(root), pt = d.points[i], col = d.colors[root.hartColor] || {};
    if (!pt) return;
    root.hartOn = i;
    $$('[data-inside]', root).forEach(function (b) {
      var on = +b.getAttribute('data-inside') === i;
      if (b.getAttribute('role') === 'tab') { b.setAttribute('aria-selected', on); b.setAttribute('tabindex', on ? 0 : -1); if (on) { var p = $('[data-inside-panel]', root); if (p) p.setAttribute('aria-labelledby', b.id); } }
      else b.setAttribute('aria-pressed', on);
    });
    var tt = $('[data-inside-title]', root), tx = $('[data-inside-text]', root);
    if (tt) tt.textContent = pt.title || '';
    if (tx) tx.textContent = pt.text || '';
    swapPic($('[data-inside-img]', root), (col.details || [])[i], pt.alt || '');
  }
  function insideColor(root, c) {
    var d = insideData(root), col = d.colors[c]; if (!col) return;
    root.hartColor = c;
    var name = $('[data-inside-cname]', root); if (name) name.textContent = col.name;
    var map = $('[data-inside-map]', root);
    if (map) { swapPic(map, col.map, map.alt.replace(/ in [^,]+,/, ' in ' + col.name + ',')); map.parentNode.classList.toggle('studio', !!col.studio); }
    var link = $('[data-inside-link]', root); if (link && col.url) link.href = col.url;
    insideShow(root, root.hartOn || 0);
  }

  /* ------------------------------------------------------- one click handler */
  D.addEventListener('click', function (e) {
    var t = e.target, el;
    if (!t.closest) return;
    if ((el = t.closest('[data-card-side]'))) {                 // the Front and Back switch on a card
      var c = el.closest('[data-card]'), side = el.getAttribute('data-card-side');
      if (c) { c.setAttribute('data-side', side); $$('[data-card-side]', c).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-card-side') === side); }); }
      return;
    }
    if ((el = t.closest('[data-tg-pick]'))) {                    // matching sets: choose the colors of a pair
      var card = el.closest('[data-tg]'), n = el.getAttribute('data-tg-pick'), opt = card && $('template[data-tg-opt="' + n + '"]', card);
      if (!opt) return;
      $$('[data-tg-pick]', card).forEach(function (b) { b.setAttribute('aria-pressed', b === el); });
      var href = opt.getAttribute('data-href');
      $$('a.tg__media, [data-tg-go]', card).forEach(function (a) { a.setAttribute('href', href); });
      var w = $('[data-tg-words]', card); if (w) w.textContent = opt.getAttribute('data-words');
      var media = $('.tg__media', card), old = media && media.firstElementChild;
      if (!media || !old) return;
      var put = function () { var pic = opt.content.firstElementChild; if (pic) media.replaceChild(pic.cloneNode(true), media.firstElementChild); };
      if (reduced()) put(); else { old.classList.add('is-swap'); W.setTimeout(put, 200); }
      return;
    }
    if ((el = t.closest('[data-looks-go]'))) {                    // outfit ideas: previous and next
      var sec = el.closest('[data-looks]'), tr = sec && $('[data-looks-track]', sec), first = tr && tr.firstElementChild;
      if (!first) return;
      var gap = parseFloat(W.getComputedStyle(tr).columnGap) || 16;
      tr.scrollBy({ left: +el.getAttribute('data-looks-go') * (first.offsetWidth + gap), behavior: reduced() ? 'auto' : 'smooth' });
      return;
    }
    if ((el = t.closest('[data-inside]'))) {                      // the details: a point or a tab
      var root = el.closest('[data-inside-root]'); if (root) insideShow(root, +el.getAttribute('data-inside'));
    }
  });
  D.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches && t.matches('[data-inside-color]')) { var root = t.closest('[data-inside-root]'); if (root) insideColor(root, +t.value); }
  });
  D.addEventListener('keydown', function (e) {                    // the details' tabs: arrow keys move between them
    var t = e.target;
    if (!t.closest || !t.closest('.inside__tabs')) return;
    var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if (!d) return;
    var root = t.closest('[data-inside-root]'), data = insideData(root), n = data.points.length; if (!n) return;
    e.preventDefault();
    var to = ((root.hartOn || 0) + d + n) % n; insideShow(root, to);
    var tab = $$('.inside__tabs [data-inside]', root)[to]; if (tab) tab.focus();
  });
  W.addEventListener('resize', function () { W.clearTimeout(W.HART_RZ); W.HART_RZ = W.setTimeout(function () { $$('[data-looks]').forEach(looksSync); }, 120); });

  /* ----------------------------------------------------------------- boot */
  function boot(scope) { glints(scope); looksInit(scope); }
  boot(D);
  lightUp();
  W.clearTimeout(W.HART_INTRO_T);
  if (W.HART_INTRO) entrance(); else D.documentElement.classList.remove('is-intro');
  D.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
